let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kaE2F")).then(() => parcelRequire('hqpaf'));